import * as React from 'react';
import { IconMinus12, IconPlus12, UIText2 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface ITextareaProps {
  type: 'plus' | 'minus';
  textarea: React.ReactNode;
  counter?: React.ReactNode;
}

export const TextareaReview = ({ type, textarea, counter }: ITextareaProps) => {
  const title = type === 'plus' ? 'Плюсы' : 'Минусы';
  const icon =
    type === 'plus' ? (
      <div className={styles['icon']}>
        <IconPlus12 />
      </div>
    ) : (
      <div className={styles['icon']}>
        <IconMinus12 />
      </div>
    );

  return (
    <div className={styles['root']}>
      <div className={styles['title']}>
        <UIText2>
          {icon}
          {title}
        </UIText2>
      </div>
      <div className={styles['textarea']}>{textarea}</div>
      <div className={styles['counter']}>{counter}</div>
    </div>
  );
};
